import React from 'react'
import { Grid } from '@mui/material'
import { format } from 'date-fns'
import { localeDateFormat } from '../../utils/localeUtils'
import CardTitle from '../../shared/UI/CardTitle'
import Paragraph from '../../shared/UI/Paragraph'
import { ManAuthRequestResponse } from '../../types/ManAuthRequests'
import Card from '../../shared/layout/Card'

interface DurationCardProps {
  manAuthRequest: ManAuthRequestResponse | null
}

const labelStyle = {
  fontSize: '12px',
  fontWeight: 'bold',
  lineHeight: '130%',
  letterSpacing: '0em',
  fontVariationSettings: '"opsz" auto',
  color: '#3D3D3D',
}

export default function DurationCard({ manAuthRequest }: DurationCardProps) {
  return (
    <Card
      title="Duration"
      icon={<CardTitle title={`${manAuthRequest?.totalHours || 0} hours`} />}
      noDivider
    >
      <Grid container spacing={1} mt={1}>
        {/* Date from row */}
        <Grid container item xs={12}>
          <Grid item xs={6}>
            <Paragraph style={labelStyle}>Date from</Paragraph>
          </Grid>
          <Grid item xs={6} display="flex" justifyContent="flex-end">
            <Paragraph style={labelStyle}>
              {manAuthRequest?.dateFrom
                ? new Date(manAuthRequest.dateFrom).toLocaleDateString(navigator.language)
                : 'N/A'}
            </Paragraph>
          </Grid>
        </Grid>

        {/* Date to row */}
        <Grid container item xs={12}>
          <Grid item xs={6}>
            <Paragraph style={labelStyle}>Date to</Paragraph>
          </Grid>
          <Grid item xs={6} display="flex" justifyContent="flex-end">
            <Paragraph style={labelStyle}>
              {manAuthRequest?.dateTo
                ? new Date(manAuthRequest.dateTo).toLocaleDateString(navigator.language)
                : 'N/A'}
            </Paragraph>
          </Grid>
        </Grid>

        {/* Date submitted row */}
        <Grid container item xs={12}>
          <Grid item xs={6}>
            <Paragraph style={labelStyle}>Date submitted</Paragraph>
          </Grid>
          <Grid item xs={6} display="flex" justifyContent="flex-end">
            <Paragraph style={labelStyle}>
              {manAuthRequest?.createdDateTime
                ? format(new Date(manAuthRequest.createdDateTime), `${localeDateFormat}, HH:mm`)
                : 'N/A'}
            </Paragraph>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  )
}
